import Timeline from './Timeline';
import TimelineItem from './TimelineItem';

// export types
export type { TimelineProps } from './Timeline';
export type { TimelineItemProps } from './TimelineItem';

// export components
export { Timeline, TimelineItem };
export default Timeline;
